<template>
  <div class="flex flex-row items-center space-x-4" style="flex: none">
    <!-- <language-switcher /> -->
    <div class="flex flex-row items-center space-x-4" v-if="isAuthenticated">
      <router-link :to="registerUrl" v-if="isRegistrationOpen == 'true'">
        <v-btn v-if="isRegistrationOpen" class="text-[#1C244B] bg-white hover:text-[#1C244B]">
          {{ $t('register') }}
        </v-btn>
      </router-link>
      <router-link :to="loginUrl">
        <v-btn class="text-[#1C244B] bg-white hover:text-[#1C244B]">
          {{ $t('login.title') }}
        </v-btn>
      </router-link>
    </div>
    <div class="container mx-auto p-6 max-w-3xl">
      <h1 class="text-2xl font-bold mb-4">Privacy Policy</h1>
      <p class="text-sm text-gray-500">Effective Date: 01/03/2025</p>
      <p class="mt-4">
        Welcome to <strong>CertifAI</strong>! Your privacy is important to us. This Privacy Policy
        explains how we handle your data when you use our web tool.
      </p>
      <h2 class="text-lg font-semibold mt-6">Data Collection and Storage</h2>
      <p>
        CertifAI does not collect, store, or retain any personal data. The tool operates as a
        sandbox environment, and all user activities are temporary.
      </p>

      <h2 class="text-lg font-semibold mt-6">Temporary Nature of Data</h2>
      <p>
        Any data processed within CertifAI exists only for the duration of the session. All
        user-generated content and interactions within the platform are permanently deleted on a
        weekly basis. Once deleted, data cannot be recovered.
      </p>

      <h2 class="text-lg font-semibold mt-6">No Third-Party Sharing</h2>
      <p>
        Since CertifAI does not collect or store any user data, we do not share any information with
        third parties.
      </p>

      <h2 class="text-lg font-semibold mt-6">Cookies and Tracking</h2>
      <p>
        CertifAI does not use cookies, tracking mechanisms, or analytics tools to monitor user
        activity.
      </p>

      <h2 class="text-lg font-semibold mt-6">Security Measures</h2>
      <p>
        Although no user data is stored, we maintain strict security protocols to ensure a safe and
        reliable sandbox environment.
      </p>

      <h2 class="text-lg font-semibold mt-6">Changes to This Privacy Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Any modifications will be reflected
        with a new effective date at the top of this page.
      </p>

      <h2 class="text-lg font-semibold mt-6">Contact Us</h2>
      <p>
        If you have any questions or concerns regarding this Privacy Policy, please contact us at
        <a href="mailto:gledakis@ubitech.eu" class="text-blue-500 underline">gledakis@ubitech.eu</a
        >.
      </p>

      <p class="mt-6">
        By using CertifAI, you acknowledge and agree to the terms outlined in this Privacy Policy.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
};
</script>

<style scoped>
.container {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
</style>
